import type OlMap from 'ol/Map'

import { createBreadcrumbAndRoutePolylineLayers } from './breadcrumbAndRoutes/createBreadcrumbAndRoutePolylineLayers'
import { createDepotLayer } from './depot/createDepotLayer'
import { createDeviceLayer } from './device/createDeviceLayer'
import { createDeviceEventLayer } from './deviceEvent/createDeviceEventLayer'
import { createDrawLayer } from './draw/createDrawLayer'
import { createExecutionEventsLayer } from './executionEvents/createExecutionEventsLayer'
import { createGeofenceLayer } from './geofence/createGeofenceLayer'
import { createOrderLayer } from './order/createOrderLayer'
import { createPinLayer } from './pin/createPinLayer'
import { createPlaceLayer } from './place/createPlaceLayer'
import { createRegionLayer } from './region/createRegionLayer'
import { createRoadSegmentLayer } from './roadSegment/createRoadSegmentLayer'
import { createTrafficAreaLayer } from './trafficArea/createTrafficAreaLayer'
import { createVehicleLayer } from './vehicle/createVehicleLayer'
import { createVoiceEventsLayer } from './voiceEvents/createVoiceEventsLayer'

export const initializeMapLayers = (map: OlMap) => {
  // ATTENTION: the order of creation matters. It'll affect a layer's z-index.

  // Marker layers
  createRegionLayer(map)
  createTrafficAreaLayer(map)
  createRoadSegmentLayer(map)
  createBreadcrumbAndRoutePolylineLayers(map)
  createPlaceLayer(map)
  createOrderLayer(map)
  createDepotLayer(map)
  createGeofenceLayer(map)
  createDeviceLayer(map)
  createVehicleLayer(map)
  createDeviceEventLayer(map)

  // order execution events and PODs
  createExecutionEventsLayer(map)

  // order voice events
  createVoiceEventsLayer(map)

  // inspect and location pins layer
  createPinLayer(map)

  // Editable Area and Editable Segment layer
  createDrawLayer(map)
}
